function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1286.37,1109.05l-640,370-640-370v-740l640-370,640,370Z",
  transform: "translate(-6.37 0.95)",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M646.37,1201.55v231.3L113,1124.45l533.4,77.1V739.05l-639.9,370h-.1l320-555-160-92.5-120,485.6v-555l120,69.4,480-462.5-640,370v740l640,370,640-370Z",
  transform: "translate(-6.37 0.95)",
  fill: "#007f38"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M646.37,739.05V-.95l-320,555Zm600-346.9v647.5l-280-485.6-320,185,640,370v-740l-640-370,320,555Z",
  transform: "translate(-6.37 0.95)",
  fill: "#007f38"
});

var SvgLogoExante = function SvgLogoExante(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1280 1480",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoExante, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-exante.f6cec158.svg";
export { ForwardRef as ReactComponent };